import { Link } from 'react-router-dom';

export  default  function SimpleSidebarItem({item ,padding=false} )
{
    return(<>
        <li>
            <a
                href={item.link}
                className={`text-xs flex items-center gap-2 w-full p-2 py-4 transition duration-75 group hover:bg-slate-700  bg-transparent text-white  hover:text-primary ${padding?"pr-5":""}`}
            >
                <span className={"font-bold  text-slate-900 "}>
                {item.icon}
                    </span>
                {item.title}
            </a>
        </li>
    </>)
}
